import React, {useEffect, useState} from "react";
import NcImage from "components/NcImage/NcImage";
import NcLink from "../../components/NcLink/NcLink";
import {auth, db, storage} from "configs/firebase-config";
import {
  collection,
  deleteDoc,
  doc,
  DocumentData,
  getDocs,
  increment,
  limit,
  onSnapshot,
  orderBy,
  query,
  startAfter,
  updateDoc,
  where
} from "firebase/firestore";

import {deleteObject, ref} from "firebase/storage";
import NextPrev from "../../components/NextPrev/NextPrev";
import {useHistory} from "react-router";
import {displayToast, toastType} from "../../global/Functions";
import ModalEditPost from "../../components/ModalEditPost/ModalEditPost";

let lastDoc: DocumentData;
let firstDoc: DocumentData;
let currentPage: number;
const DashboardPosts = () => {
  const history = useHistory();
  const [posts, setPosts] = useState<DocumentData>([]);
  const [postsPerPage, setPostsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [lBound, setLBound] = useState(0);
  const [uBound, setUBound] = useState(0);

  const [isEditPost, setIsEditPost] = useState(false);
  const [editPost, setEditPost] = useState<any>();
  const closeModalEditPost = () => setIsEditPost(false);
  const openModalEditPost = () => setIsEditPost(true);

  const postDocRef = doc(db, "posts", `${auth.currentUser?.uid}`);
  const postsCollectionRef = collection(postDocRef, "posts");

  const q = query(postsCollectionRef,
    where("userId", "==", auth.currentUser?.uid),
    orderBy("createdAt", "desc"),
    limit(postsPerPage)
  );

  const displayPosts = (snapshot: DocumentData) => {
    firstDoc = snapshot[0];
    lastDoc = snapshot[snapshot.length - 1];
    setPosts(snapshot.map((doc: any) => {
      return {
        uid: doc.get("userId"),
        id: doc.id,
        liveStatus: true,
        payment: "Not Applicable",
        ...doc.data()
      };
    }));
  }

  useEffect(() => {
    const unsubscribePost = onSnapshot(q, async (snapshot) => {
      const source = snapshot.metadata.fromCache ? "local cache" : "server";
      console.log("Post came from " + source);
      displayPosts(snapshot.docs);
      currentPage = snapshot.docs.length;
      setLBound(1);
      setUBound(currentPage);
    })
    const unsubscribeStat = onSnapshot(doc(db, "stats", `${auth.currentUser?.uid}`), (result) => {
      setTotal(result.get("posts"));
    })

    return () => {
      unsubscribePost();
      unsubscribeStat();
    };
  }, [postsPerPage])

  useEffect(() => {
    setUBound(lBound + currentPage - 1);
  }, [lBound])

  const handleDelete = async (documentID: string, image: any) => {
    try {
      await deleteDoc(doc(postsCollectionRef, documentID));
      displayToast("Post Deleted", toastType.success);
    } catch (error){
      displayToast("Couldn't delete post", toastType.error);
    }

    await updateDoc(doc(db, "stats", `${auth.currentUser?.uid}`), {posts: increment(-1)});

    // Check if other posts have same picture
    if (!image) return;
    const match = await getDocs(query(postsCollectionRef, where("image.name", "==", image)));
    if (match.size >= 1) return;

    const storageRef = ref(storage, `posts/${auth.currentUser?.uid}/${image}`);

    deleteObject(storageRef).then(() => {
      console.log("File deleted")
    }).catch((error) => {
      console.log(error.code);
    });
  }

  const nextBatch = (lastDocument: DocumentData) => {
    const q = query(postsCollectionRef,
      where("userId", "==", auth.currentUser?.uid),
      orderBy("createdAt", "desc"),
      startAfter(lastDocument),
      limit(postsPerPage)
    );
    getDocs(q).then((snapshot) => {
      if (snapshot.docs.length >= 1) {
        displayPosts(snapshot.docs);
        currentPage = snapshot.docs.length;
        setLBound(uBound + 1);
        setUBound(uBound + snapshot.docs.length);
      }
    })

  }
  const previousBatch = (firstDocument: DocumentData) => {
    const q = query(postsCollectionRef,
      where("userId", "==", auth.currentUser?.uid),
      orderBy("createdAt", "asc"),
      startAfter(firstDocument),
      limit(postsPerPage)
    );

    getDocs(q).then((snapshot) => {
      if (snapshot.docs.length >= 1) {
        displayPosts(snapshot.docs.reverse());
        currentPage = snapshot.docs.length;
        setLBound(lBound - currentPage);
      }
    })
  }
  return (
    <div className="flex flex-col space-y-8">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full px-1 sm:px-6 lg:px-8">
          <div className="shadow dark:border dark:border-neutral-800 overflow-hidden sm:rounded-lg">
            <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-800">
              <thead className="bg-neutral-50 dark:bg-neutral-800">
              <tr className="text-left text-xs font-medium text-neutral-500 dark:text-neutral-300 uppercase tracking-wider">
                <th scope="col" className="px-6 py-3">
                  Article
                </th>
                <th scope="col" className="px-6 py-3">
                  Category
                </th>
                <th scope="col" className="px-6 py-3">
                  Decentralised Payment
                </th>

                <th scope="col" className="relative px-6 py-3">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
              </thead>
              <tbody
                className="bg-white dark:bg-neutral-900 divide-y divide-neutral-200 dark:divide-neutral-800">
              {
                posts.map((item: DocumentData) => (
                  <tr key={item.id}>
                    <td className="px-6 py-4">
                      <div className="flex items-center w-96 lg:w-auto max-w-md overflow-hidden">
                        <NcImage
                          containerClassName="flex-shrink-0 h-12 w-12 rounded-lg overflow-hidden lg:h-14 lg:w-14"
                          src={item.image.downloadURL}
                        />
                        <div className="ml-4 flex-grow">
                          <h2 className="inline-flex line-clamp-2 text-sm font-semibold  dark:text-neutral-300">
                            <a onClick={() => history.push(`/single/${item.uid}/${item.id}`)}>
                              {item.title}
                            </a>
                          </h2>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-teal-100 text-teal-900 lg:text-sm">
                        {item.categories[0].name}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500 dark:text-neutral-400">
                      <span> {item.payment}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-neutral-300">
                      <button
                        onClick={() => {setEditPost(item); openModalEditPost()}}
                        className="text-primary-800 dark:text-primary-500 hover:text-primary-900"
                      >
                        Edit
                      </button>
                      {` | `}
                      <button
                        className="text-rose-600 hover:text-rose-900"
                        onClick={async () => await handleDelete(String(item.id), item.image.name)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {total > 0 ?
        <>
          <NextPrev
            btnClassName="w-11 h-11 text-xl"
            onClickNext={() => {
              nextBatch(lastDoc)
            }}
            onClickPrev={() => {
              previousBatch(firstDoc)
            }}
          />
          {/*TODO: FRONT-END TO STYLE FOLLOWING DROP DOWN LIST*/}
          <div>
            <select
              defaultValue={postsPerPage}
              onChange={(e) => {setPostsPerPage(Number(e.target.value))}}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
            <span>Showing {lBound}-{uBound} of {total}</span>
          </div>
        </>
        :
        <>
          <span className="block text-lg mb-3">
            You haven't posted anything yet!
            {" "}
            <NcLink to="/dashboard/submit-post">Publish An Article</NcLink>
          </span>
        </>}
      {editPost ?
        <ModalEditPost show={isEditPost} onCloseModalEditPost={closeModalEditPost} data={editPost}></ModalEditPost> :
        <></>
      }

    </div>
  );
};

export default DashboardPosts;
